import camelCase from 'lodash/camelCase';
import { Fragment } from 'react';
import { useMediaQuery } from '~/app/lib/use-media-query';
import UniversalText from '../universal-text/universal-text';
import BaseFixedFirstColumnTable from './base-fixed-first-column-table';
import getEditingConfig from './lib/editing-config';
import { FixedFirstColumnTableProps, TableColumn, TableRow } from './types';

const FixedFirstColumnTable = ({
  centeredInParent = false,
  data = [],
  tableStyle = '',
  className = '',
  transposed = false,
  hideHeader = false,
  striped = false,
  rowKeyField = 'id',
}: FixedFirstColumnTableProps) => {
  const size = useMediaQuery();
  const isMobile = size === 'sm';

  const tableData: TableRow[] = data.map((row) => {
    const mappedRow: Record<string, any> = {};
    // Map each attribute to camelCase key with its value
    if (row.attributes) {
      row.attributes.forEach((attribute) => {
        const key = camelCase(attribute.header);
        mappedRow[key] = attribute.value;
      });
    }

    if (row.highlight !== undefined) {
      mappedRow.highlight = row.highlight;
    }

    return mappedRow as TableRow;
  });

  const columns = data[0]?.attributes?.map((attribute) => ({
    key: camelCase(attribute.header),
    header: attribute.header,
  }));

  const enableHighlighting = ['styled-light-green'].includes(tableStyle);

  const renderCell = (column: TableColumn, row: TableRow) => {
    const value = row[column.key];
    if (
      transposed &&
      tableStyle === 'styled-light-green' &&
      column.key === 'originalHeader'
    ) {
      return value.text;
    }

    if (isMobile && tableStyle === 'styled-light-green') {
      value.groupButton.left = true;
      value.groupButton.center = false;
      value.groupButton.right = false;
    }

    return (
      <UniversalText
        {...value}
        defaultOptions={{ text: { textType: 'text' } }}
      />
    );
  };

  return (
    <Fragment>
      <BaseFixedFirstColumnTable
        columns={columns}
        tableData={tableData}
        tableStyle={tableStyle}
        centeredInParent={centeredInParent}
        className={className}
        enableHighlighting={enableHighlighting}
        hideHeader={hideHeader}
        striped={striped}
        transposed={transposed}
        rowKeyField={rowKeyField}
        renderCell={renderCell}
      />
    </Fragment>
  );
};

FixedFirstColumnTable.getEditingConfig = getEditingConfig;

export default FixedFirstColumnTable;
